import React from 'react'


export default function Dashbord() {

  return (
    <div className='flex justify-center items-center'>
      <div>
      <h1 className='uppercase text-4xl font-thin text-center text-primary'> Welcome to MShop Dashbord</h1>
      </div>
    </div>
  )
}
